import React from 'react'

import InputGroup, { CheckboxValue } from 'components/shared/InputGroup'
import Tooltip from 'components/shared/Tooltip'
import { useStoreActions, useStoreState } from 'store'
import infoIcon from 'assets/info.svg'

const options = [
  { label: 'All', value: 'All' },
  { label: '0', value: 'Zero' },
  { label: '0-1', value: 'ZeroToOneInclusive' },
  { label: '1-2', value: 'OneToTwo' },
]

export default function Points() {
  const {
    mortgageType,
    purchase: { points: purchasePoints },
    refinance: { points: refinancePoints },
  } = useStoreState(state => state.dimensions.dimensions)
  const { onInputTracking } = useStoreActions(actions => actions.tracking)
  const { updateDimensions } = useStoreActions(actions => actions.dimensions)
  const isDesktop = useStoreState(state => state.dimensions.isDesktop)

  const handleChange = (points: CheckboxValue) => {
    const updateObj: {
      [key: string]: { points: CheckboxValue }
    } = {}
    updateObj[mortgageType.toLowerCase()] = { points }
    updateDimensions(updateObj)
    // Per the options, the points should always be a string, but make sure that it is
    onInputTracking({ name: 'points', type: 'POINTS', label: 'points', value: points.toString() })
  }
  return (
    <>
      <div className="form-element-container mb-2">
        <div className="FormLabel display-flex justify-content-space-between align-items-baseline w-full">
          Points
          {isDesktop && (
            <Tooltip
              buttonText=""
              className="text-blue display-inline-block pl-2"
              style={{ fontSize: '14px' }}
              underline={false}
              icon={infoIcon}
              iconAltText="Info"
              arrowPosition="anchorRight"
              responsivePosition={true}
            >
              <p className="text-slate type-body-two p-2">
                <span className="font-circular-bold">Fees</span> paid directly to the lender in exchange for a reduced
                rate.
              </p>
            </Tooltip>
          )}
        </div>
        <p className={`type-body-three mb-2 text-slate ${isDesktop ? 'display-none' : ''}`}>
          Fees paid directly to the lender in exchange for a reduced rate.
        </p>
        <InputGroup
          data-testid="points"
          options={options}
          className="FormButtonGroup FormButtonGroup--small FormButtonGroup--fill mb-4"
          value={mortgageType === 'Purchase' ? purchasePoints : refinancePoints}
          onClick={handleChange}
        />
      </div>
    </>
  )
}
